import React, { useEffect, useState, useCallback } from "react";
import cn from "classnames";
import styles from "./AddBattery.module.scss";
// import { getRequest, postRequest, putRequest } from "services/axiosBaseClient";
import { getRequestInAssets as getRequestOnEnterprise } from "services/axiosAssetsBaseClient";
import {
  getRequestInService as getRequest,
  postRequestInService as postRequest,
  putRequestInService as putRequest,
} from "services/axiosServiceBaseClient";
import Master from "../Master";
import { useHistory, Link } from "react-router-dom";
import TableAndSearch from "components/common/TableAndSearch";
import notificationService from "services/notification.service";
import { NotificationManager } from "react-notifications";
import LocalStorageService from "services/tokenlocalstorage.service";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Checkbox from "@mui/material/Checkbox";
import { act } from "react-dom/test-utils";

var id = undefined;
var action = "Submit";
var title = "Add Role";
var view = undefined;
var onlyView = false;
var readOnlyField = false;
var headerFilterParms;
var headerFilter = false;
const privilegesList = [
  {
    module: "battery",
    actions: "",
  },
  {
    module: "swappoint",
    actions: "",
  },
  {
    module: "vehicle",
    actions: "",
  },
  {
    module: "chargingpoint",
    actions: "",
  },
];

function AddRoleForm(props) {
  const initialFormValues = {
    name: "",
    description: "",
    enterpriseName: "",
    privileges: [
      {
        module: "battery",
        actions: "",
      },
      {
        module: "swappoint",
        actions: "",
      },
      {
        module: "vehicle",
        actions: "",
      },
      {
        module: "chargingpoint",
        actions: "",
      },
    ],
  };

  const [formValues, setFormValues] = useState(initialFormValues);
  const [formErrors, setFormErrors] = useState("");
  const [enterpriceName, setEnterpriceName] = useState([]);
  const [recordUpdate, setRecordUpdate] = useState(false);

  // activepageCount setActivePageCount
  const history = useHistory();

  const getRoleDataByID = async (id) => {
    await getRequest(`bss/svc/getRoleId?roleId=${id}`)
      .then((res) => {
        if (res.data != null) {
          patchForm(res.data);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  };

  const patchForm = (data) => {
    setFormErrors("");
    setFormValues({
      name: data?.name,
      id: data?.id,
      enterpriseName: data?.enterpriseName,
      description: data?.description,
      privileges: data?.privileges,
    });
    window.scrollTo({ top: 0 });
  };

  id = props.match.params.id;
  view = props.match.params.view;

  const routeChange = () => {
    history.push({
      pathname: "/Users",
      state: { table: 3, compomentRenderType: "view" },
    });
  };

  useEffect(() => {
    if (headerFilterParms && Object.keys(headerFilterParms)?.length > 0) {
    }
    if (!headerFilterParms) {
      headerFilter = false;
    }
  }, [headerFilterParms || headerFilter]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let result = validate(formValues);
    if (Object.values(result).every((x) => x === "")) {
      const obj = {
        id: formValues?.id,
        name: formValues.name,
        enterpriseName: formValues.enterpriseName,
        description: formValues.description,
        privileges: JSON.stringify(formValues.privileges),
      };

      if (action === "Update") {
        try {
          putRequest(`bss/svc/updateRole`, JSON.stringify(obj))
            .then((res) => {
              if (res && res?.data) {
                history.push({
                  pathname: "/Users",
                  state: { table: 3, compomentRenderType: "view" },
                });
              }
            })
            .catch((err) => {
              NotificationManager.error(err?.response?.data?.message);
            });
        } catch (error) {
          console.log(error);
        }
      } else {
        try {
          postRequest(`bss/svc/createRole`, JSON.stringify(obj))
            .then((res) => {
              if (res && res?.data) {
                history.push({
                  pathname: "/Users",
                  state: { table: 3, compomentRenderType: "view" },
                });
              }
            })
            .catch((error) => {
              notificationService.showNonBlacklistedError(
                error?.config?.url,
                error?.response?.data?.message
              );
              return error;
            });
        } catch (error) {
          reset();
          console.log(error);
        }
      }
    }
  };

  const validate = (formValues) => {
    const errors = {};
    if (!formValues.name) {
      errors.name = "Role name is required!";
    } else if (!/^[ A-Za-z0-9-_./&']*$/i.test(formValues.name)) {
      errors.name = "/-_&'. are the only allowed special characters";
    } else {
      errors.name = "";
    }

    if (!formValues.enterpriseName) {
      errors.enterpriseName = "Enterprise name is required!";
    } else {
      errors.enterpriseName = "";
    }

    setFormErrors(errors);
    return errors;
  };

  const reset = () => {
    setFormValues(initialFormValues);
  };

  useEffect(() => {
    if (recordUpdate) {
      window.scrollTo({ top: 0 });
      setRecordUpdate(false);
    }
    if (id !== undefined && view == undefined) {
      action = "Update";
      title = "Update Role";
      readOnlyField = false;
      onlyView = false;
      getRoleDataByID(id);
    } else if (id !== undefined && view !== undefined) {
      action = "view";
      title = "View Role";
      readOnlyField = false;
      onlyView = true;
      getRoleDataByID(id);
    } else {
      const headerFilterObj = JSON.parse(
        LocalStorageService.get("queryHeader")
      );
      setFormValues({
        ...formValues,
        ["enterpriseName"]: headerFilterObj?.enterprise,
      });

      title = "Add Role";
      onlyView = false;
      readOnlyField = false;
      action = "Submit";
    }
  }, [recordUpdate]);

  const getEnterprise = useCallback(async () => {
    await getRequest("enterprise/get?offset=0&pageSize=50")
      .then((res) => {
        if (res?.data && res?.data?.enterpriseDetailDtoList?.length >= 1) {
          setEnterpriceName(res?.data?.enterpriseDetailDtoList);
        }
      })
      .catch((err) => {
        console.error("Error", err);
      });
  });

  const handlePrivilegesChecked = (module) => {
    const privileges = formValues.privileges;
    let action =
      privileges && privileges.length > 0
        ? privileges
            ?.filter((item) => item.module === module)[0]
            ?.actions.replace(/[\,[\]']+/g, "")
        : "";
    if (action.includes("r")) {
      action = action.replace("r", "");
      let str = "[";
      action.split("").map((a, i) => {
        if (action.length - 1 == i) {
          str = str + "'" + a + "'" + "]";
        } else {
          str = str + "'" + a + "',";
        }
      });
      privileges.filter((item) => item.module === module)[0].actions = str;
    } else {
      action = action + "r";
      let str = "[";
      action.split("").map((a, i) => {
        if (action.length - 1 == i) {
          str = str + "'" + a + "'" + "]";
        } else {
          str = str + "'" + a + "',";
        }
      });
      console.log(str);
      privileges.filter((item) => item.module === module)[0].actions = str;
    }

    setFormValues({
      ...formValues,
      ["privileges"]: privileges,
    });
  };

  useEffect(() => {
    getEnterprise();
  }, []);

  return (
    <>
      <div id="AddRole_form_block" className={cn(styles.flex_item1)}>
        <div id="AddRole_form_block1" className={cn(styles.flex1)}>
          <h2
            id="AddRole_form_Heading"
            className={cn(styles.medium_title, styles.medium_title_layout)}
          >
            {"Roles"}
          </h2>

          <div
            id="AddRole_form_layout"
            className={cn(styles.group, styles.group_layout)}
          >
            <form id="AddRole_form">
              <div
                id="AddRole_form_Title"
                className={cn(styles.flex3, styles.flex3_layout)}
              >
                <h3 className={cn(styles.subtitle, styles.subtitle_layout)}>
                  {title}
                </h3>
                <hr className={cn(styles.line, styles.line_layout)} />
                <div
                  id="AddRole_form_row1"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div id="AddRole_ZoneName" className={cn(styles.flex2_item)}>
                    <div
                      id="AddRole_ZoneName_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddRole_Name_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Role Name*"}
                      </div>
                      <input
                        id="AddRole_Name_input"
                        name="name"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues.name}
                        onChange={handleChange}
                        disabled={onlyView || readOnlyField}
                        maxLength={40}
                      />
                    </div>
                    <p>{formErrors.name}</p>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />

                  <div
                    id="AddRole_EnterpriseName"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddRole_EnterpriseName_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddRole_EnterpriseName_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Enterprise Name*"}
                      </div>
                      <select
                        id="AddRole_EnterpriseName_select"
                        name="enterpriseName"
                        className={cn(
                          styles.line1,
                          styles.line1_layout,
                          styles.style_select
                        )}
                        value={formValues.enterpriseName}
                        onChange={handleChange}
                        disabled={onlyView || action == "Update"}
                        type="select"
                      >
                        <option value="">Enterprise Name</option>
                        {enterpriceName?.map((obj) => {
                          return (
                            <option value={obj.name}>
                              {obj.enterpriseName}
                            </option>
                          );
                        })}
                      </select>
                    </div>
                    <p>{formErrors.enterpriseName}</p>
                  </div>
                </div>

                <div
                  id="AddRole_form_row2"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div
                    id="AddRole_Description"
                    className={cn(styles.flex2_item)}
                  >
                    <div
                      id="AddRole_Description_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="AddRole_Description_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Description"}
                      </div>
                      <input
                        id="AddRole_Description_input"
                        name="description"
                        className={cn(styles.line1, styles.line1_layout)}
                        value={formValues.description}
                        onChange={handleChange}
                        disabled={onlyView || readOnlyField}
                        maxLength={40}
                      />
                    </div>

                    <p>{formErrors.description}</p>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}></div>
                </div>

                <div
                  id="AddRole_form_row2"
                  className={cn(styles.flex2, styles.flex2_layout)}
                >
                  <div id="Role_privilege" className={cn(styles.flex2_item)}>
                    <div
                      id="Role_privilege_block"
                      className={cn(styles.block3, styles.block3_layout)}
                    >
                      <div
                        id="Role_privilege_label"
                        className={cn(
                          styles.text_body,
                          styles.text_body_layout
                        )}
                      >
                        {"Role Privileges"}
                      </div>
                      <div className={cn(styles.flex2_spacer)} />
                      <TableContainer component={Paper}>
                        <Table
                          sx={{ minWidth: 750 }}
                          aria-label="caption table"
                        >
                          <TableHead>
                            <TableRow>
                              <TableCell>Action</TableCell>
                              <TableCell>Module</TableCell>
                              {/* <TableCell align="right">Description</TableCell>
                                                            <TableCell align="right">Create</TableCell>
                                                            <TableCell align="right">Read</TableCell>
                                                            <TableCell align="right">Delete</TableCell> */}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {privilegesList.map((row) => {
                              return (
                                <TableRow key={row.name}>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ textTransform: "uppercase" }}
                                  >
                                    <Checkbox
                                      onChange={() =>
                                        handlePrivilegesChecked(row.module)
                                      }
                                      checked={
                                        formValues.privileges
                                          ?.filter(
                                            (item) => item.module === row.module
                                          )[0]
                                          ?.actions.includes("r")
                                          ? true
                                          : false
                                      }
                                    />
                                  </TableCell>
                                  <TableCell
                                    component="th"
                                    scope="row"
                                    style={{ textTransform: "uppercase" }}
                                  >
                                    {row.module}
                                  </TableCell>
                                  {/* <TableCell align="right">{row.description}</TableCell>
                                                                        <TableCell disabled align="right"><input type="checkbox" id="create"  value="Create"/></TableCell>
                                                                        <TableCell align="right"><input type="checkbox" id="read"  value="Read"/></TableCell>
                                                                        <TableCell align="right"><input type="checkbox" id="delete"  value="Delete"/></TableCell> */}
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </div>
                  </div>

                  <div className={cn(styles.flex2_spacer)} />
                  <div className={cn(styles.flex2_item)}></div>
                </div>

                <div
                  id="AddRole_Button_block"
                  className={cn(styles.flex9, styles.flex9_layout)}
                >
                  <div
                    id="AddRole_Button_layout"
                    className={cn(styles.flex9_item)}
                    onClick={routeChange}
                  >
                    <div
                      id="AddRole_Button_layout1"
                      className={cn(styles.block7, styles.block7_layout)}
                      style={onlyView ? { left: "20px" } : { left: "0px" }}
                    >
                      <h5
                        id="AddRole_BackButton_Title"
                        className={cn(
                          styles.highlights1,
                          styles.highlights1_layout
                        )}
                      >
                        {onlyView ? "Back" : "Cancel"}
                      </h5>
                    </div>
                  </div>

                  <div className={cn(styles.flex9_spacer)} />
                  {action !== "view" ? (
                    <div
                      id="AddRole_SubmitButton"
                      className={cn(styles.flex9_item)}
                    >
                      <div
                        id="AddRole_SubmitButton_background"
                        onClick={handleSubmit}
                        className={cn(styles.block9, styles.block9_layout)}
                        style={{
                          backgroundColor: "#315CBB",
                          position: "absolute",
                          height: "45px",
                          width: "120px",
                          borderRadius: "5px",
                        }}
                      >
                        <h5
                          id="AddRole_SubmitButton_Title"
                          className={cn(
                            styles.highlights2,
                            styles.highlights2_layout
                          )}
                        >
                          {action}
                        </h5>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </form>
            <div className={cn(styles.flex2, styles.flex2_layout)}></div>
          </div>
        </div>
      </div>
    </>
  );
}

export default function AddRole(props) {
  let Urls = window.location.href.toString().split(window.location.host)[1];
  const data = (data) => {
    headerFilterParms = data ? data : {};
  };

  useEffect(() => {
    data();
  }, []);
  return (
    <>
      <Master
        opts={props}
        screen={AddRoleForm}
        showStatus={false}
        addRoleUrl={Urls}
        data={data}
      />
    </>
  );
}

AddRole.inStorybook = true;
